let megabusCityIds = [
    {name: "Aberdeen", id: 1},
    {name: "Aviemore", id: 2},
    {name: "Birmingham", id: 8},
    {name: "Birmingham International Airport", id: 9},
    {name: "Bournemouth", id: 11},
    {name: "Bristol", id: 13},
    {name: "Bristol UWE", id: 14},
    {name: "Cardiff", id: 20},
    {name: "Coventry", id: 27},
    {name: "Derby", id: 30},
    {name: "Dundee", id: 32},
    {name: "Edinburgh", id: 34},
    {name: "Exeter", id: 36},
    {name: "Glasgow", id: 38},
    {name: "Huddersfield", id: 45},
    {name: "Hull", id: 46},
    {name: "Inverness", id: 49},
    {name: "Kinross", id: 51},
    {name: "Leeds", id: 52},
    {name: "Leicester", id: 53},
    {name: "Liverpool", id: 54},
    {name: "London", id: 56},
    {name: "Loughborough", id: 57},
    {name: "Manchester", id: 58},
    {name: "Middlesbrough", id: 59},
    {name: "Newcastle (upon Tyne)", id: 63},
    {name: "Newport", id: 64},
    {name: "Nottingham", id: 68},
    {name: "Oxford (City Centre)", id: 71},
    {name: "Perth", id: 75},
    {name: "Pitlochry", id: 76},
    {name: "Plymouth", id: 77},
    {name: "Poole", id: 78},
    {name: "Preston", id: 80},
    {name: "Reading", id: 81},
    {name: "Sheffield", id: 90},
    {name: "Sunderland", id: 96},
    {name: "Swansea", id: 97},
    {name: "Taunton", id: 100},
    {name: "Lancaster", id: 116},
    {name: "Halbeath Interchange", id: 138},
    {name: "Cullompton", id: 152},
    {name: "Northampton", id: 166},
    {name: "Bridgwater", id: 183},
    {name: "Bristol Airport", id: 249},
    {name: "Cardiff University", id: 259},
    {name: "Heathrow Airport T2 & T3 (also T4 & T5 via Shuttle)", id: 265},
    {name: "Manchester Airport", id: 278},
    {name: "Luton Airport", id: 320},
    {name: "Wellington", id: 363},
    {name: "Nottingham University", id: 373},
    {name: "Stansted Airport", id: 385},
    {name: "Oxford (Thornhill)", id: 389},
    {name: "Mansfield / Alfreton", id: 401},
    {name: "Newcastle under Lyme", id: 403},
    {name: "Hull University", id: 404},
    {name: "Goole", id: 405},
    {name: "Bournemouth University", id: 416},
    {name: "Abington", id: 446},
    {name: "Dunbar", id: 447},
    {name: "Haggerston Castle", id: 448},

];
let flixbusCityIds = [
{name: "Birmingham", id: 14668},
{name: "Bradford", id: 46591},
{name: "Bridgend", id: 47351},
{name: "Bristol", id: 43131},
{name: "Cardiff", id: 46691},
{name: "Chester", id: 47961},
{name: "Derby", id: 46571},
{name: "Leeds", id: 43121},
{name: "Leicester", id: 46541},
{name: "Liverpool", id: 14688},
{name: "London", id: 3848},
{name: "London Heathrow", id: 47891},
{name: "Loughborough", id: 46721},
{name: "Manchester", id: 14638},
{name: "Newport (South Wales)", id: 47361},
{name: "Northampton", id: 14728},
{name: "Nottingham", id: 46581},
{name: "Sheffield", id: 43141},
{name: "Stoke on Trent", id: 14748},
{name: "Swansea", id: 46681},
{name: "Warrington", id: 47971},
{name: "York", id: 46621},
]


export {    
    megabusCityIds,
    flixbusCityIds
}